module.exports = __webpack_public_path__ + "img/img3.23702350.png";